import React, { useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import getDt from "../../utils";
import { showLoader } from "../redux/ctrl/ctrlActions";
import { updTagAct } from "../redux/project/projActions";
import Select from "react-select";
import "./pkgSel.scss";
import COLORS from "../styles/COLORS";
//import SelectInput from '../shared/Selectinput';
//import HOC from '../HOC/HOC';

function GetPkgs(getPkgs, id) {
  //    let getPkgs = useSelector(state=>state.project.packages);
  let fPkgs = getPkgs.filter((o) => o.package_id != id);
  return fPkgs;
}


const MultiTagComboStyle = {
  control: (base, state) => ({
    ...base,
    //background: "#fff",
    background: 'transparent',
    borderColor: 'transparent',
    marginTop: '-2px',
    width: 'auto',
    //opacity: 1,
    // match with the menu
    borderRadius: 0,
    // Overwrittes the different states of border
    // Removes weird border around container
    boxShadow: null,
    '&:hover': {
      borderColor: 'transparent',
      background: 'transparent',
    },
    //height: '20px',
    //'min-height': '20px',
    //width: '100px',
  }),
  menu: base => ({
    ...base,
    // override border radius to match the box
    borderRadius: 0,
    // beautify the word cut by adding a dash see https://caniuse.com/#search=hyphens for the compatibility
    hyphens: "auto",
    // kill the gap
    marginTop: '-10px',
    //innerHeight: '5px',
    textAlign: "left",
    // prevent menu to scroll y
    wordWrap: "break-word",
  }),
  menuList: base => ({
    ...base,
    // kill the white space on first and last option
    padding: 0

  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px 12px',
    paddingBottom: '6px'
  }),
  dropdownIndicator: provided => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: '4px',
    color: "hsl(0,0%,60%)"
  }),
  indicatorsContainer: (styles) => ({
    ...styles,
  }),
  indicatorSeparator: (styles) => ({
    ...styles,
    display: 'none'
  }),
  clearIndicator: (styles) => ({
    ...styles,
    marginBottom: 0,
    // marginTop: '-2px'
  }),
  singleValue: (style) => ({
    ...style,
    paddingBottom: '0.2pc'
  }),
  multiValue: (styles) => ({
    ...styles,
    marginBottom: '8px'
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    padding: '2px'
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    paddingLeft: '2px',
    paddingRight: '2px'
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? COLORS.green : 'inherit',
    '&:hover': { backgroundColor: state.isSelected ? COLORS.green : COLORS.green }
  }),
};

function DivSel(props) {
  let getDivs = useSelector((state) => state.ctrl.division_code);
  const prof = useSelector(state => state.profile)
  const dispatch = useDispatch();
  //let updA = false;
  //const SINP = useCallback( HOC(SelectInput,updA),[updA]);

  const onDivChange = (event, props) => {
    const pl = props.data;
    pl[props.column.colDef.field] = event.value;
    pl["last_updatedby"] = prof.email;
    pl["last_updatedate"] = getDt(new Date());
    pl["creation_date"] = props.data.creation_date;// getDt(new Date());
    pl["selected"] = "Y";
    dispatch(showLoader(true));
    dispatch(updTagAct(pl));
    dispatch(showLoader(false));
  };
  return (
    <div style={{ marginLeft: '-1pc' }}>
      <Select
        styles={MultiTagComboStyle}
        menuPortalTarget={document.body}
        name="division_code"
        options={getDivs}
        placeholder="Div.."
        onChange={(event) => onDivChange(event, props)}
        defaultValue={{ value: props.data.gen_prod_adv, label: getDivs.find(i => i.value === props.data.gen_prod_adv)?.label }}
      />
    </div>
  );
}

export default DivSel;
